<template>
  <div :class="$style.container">
    <div :class="$style.tips">
      <p>温馨提示</p>
      <p>1. 本月可开发票只针对服务费以及注册费。</p>
      <p>2. 本月产生的服务费以及注册费在下个月二号以后才可以索取发票。</p>
      <p>3. 发票基于订单开具，不可拆分开票。</p>
      <p>
        4. 识道网络单张发票金额限额100万，索取金额超过100万将拆分成多张发票开具。
      </p>
    </div>

    <Step :data="stepList" :step="step" />

    <!-- 可申请的发票信息 -->
    <div v-show="step === 1">
      <Row>
        <Item title="类型">
          <el-select v-model="status" placeholder="全部">
            <el-option
              v-for="(item, index) in statusList"
              :key="index"
              :label="item.invoiceName"
              :value="item.invoiceType"
            />
          </el-select>
        </Item>

        <Item title="交易时间">
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="选择日期"
          />
          <div :class="$style.divider"></div>
          <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="选择日期"
          />
        </Item>

        <Item title="可开票金额">
          <el-input
            :class="$style.money_input"
            v-model="minMoney"
            @input="onMoneyChange($event, 'min')"
          />
          <div :class="$style.divider"></div>
          <el-input
            :class="$style.money_input"
            v-model="maxMoney"
            @input="onMoneyChange($event, 'max')"
          />
        </Item>

        <Button type="primary" size="small" @click="submitSearch(1)">
          查询
        </Button>
        <Button size="small" @click="resetSearch">重置</Button>
      </Row>

      <div :class="$style.money_info">
        <div :class="$style.money_left">
          <div :class="$style.money_item">
            <span :class="$style.money_number">
              {{ amountTotal.invoicingAmount || 0 }}
            </span>
            <span :class="$style.money_name">本月可开票金额</span>
          </div>
          <Divider direction="vertical" />
          <div :class="$style.money_item">
            <span :class="$style.money_number">
              {{ amountTotal.totalAmount || 0 }}
            </span>
            <span :class="$style.money_name">可开票总金额</span>
          </div>
          <Divider direction="vertical" />

          <div :class="$style.money_item">
            <span :class="$style.money_number">
              {{ amountTotal.invoicedAmount || 0 }}
            </span>
            <span :class="$style.money_name">已开票总金额</span>
          </div>
        </div>
        <div :class="$style.money_right">
          <span :class="$style.invoicing_amount">
            已选开票金额：<span class="theme-color"> ￥{{ selectAmount }}</span>
          </span>
          <Button
            :class="$style.apply_btn"
            type="primary"
            round
            @click="toFillApply"
          >
            申请发票
          </Button>
        </div>
      </div>

      <!-- 列表结果 -->
      <div :class="$style.time_type">
        <span
          v-for="(item, index) in timeTypeList"
          :key="index"
          :class="[timeType === index ? $style.btn_active : '']"
          @click="changeListType(index)"
        >
          {{ item }}
        </span>
        <span :class="$style.total">（{{ total }}）</span>
      </div>

      <el-table
        ref="multipleTable"
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="30" align="center" />

        <el-table-column
          prop="createdTime"
          label="交易时间"
          width="80"
          align="center"
        />

        <el-table-column prop="type" label="类型" width="50" align="center" />

        <el-table-column
          prop="money"
          label="交易金额"
          width="50"
          align="center"
        />

        <el-table-column
          prop="invoiceAmount"
          label="可开票金额"
          width="50"
          align="center"
        />

        <el-table-column
          prop="remark"
          label="备注"
          width="150"
          align="center"
        />
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </div>

    <!-- 填写发票信息 -->
    <ReceiptFill
      v-if="step === 2"
      :list="selectList"
      :selectAmount="selectAmount"
      @stepBack="stepBack"
    />
  </div>
</template>

<script>
import {
  getInvoiceType,
  getInvoiceAmountTotal,
  getInvoiceAmountList,
} from "@server";

import ReceiptFill from "./ReceiptFill.vue";

export default {
  name: "ReceiptApply",
  components: {
    ReceiptFill,
  },
  data() {
    return {
      stepList: [
        "选择开票订单",
        "填写发票信息和地址",
        "后台审核，邮寄发票",
        "签收快递，开票成功",
      ],
      step: 1, // 发票申请步骤
      statusList: [],
      status: "",
      startTime: "",
      endTime: "",
      minMoney: "",
      maxMoney: "",

      amountTotal: {},

      timeTypeList: ["本月可开", "下月可开", "已开票记录"],
      timeType: 0, // 时间类型

      loading: false,
      page: 1,
      limit: 50,
      showList: [],
      total: 0,

      selectList: [],
    };
  },
  computed: {
    selectAmount() {
      return this.selectList.reduce((pre, cur) => {
        return pre + cur.invoiceAmount;
      }, 0);
    },
  },
  methods: {
    async getInvoiceAmountTotal() {
      const res = await getInvoiceAmountTotal();
      if (res.code === 200) {
        this.amountTotal = res.data;
      }
    },
    // 发票类型
    async getInvoiceType() {
      const res = await getInvoiceType();
      if (res.code === 200) {
        this.statusList = res.data;
      }
    },
    async submitSearch(page = 1) {
      (this.loading = true), (this.page = page);

      const params = {
        page,
        limit: this.limit,
        timeType: this.timeType,
      };
      this.startTime && (params.startTime = this.startTime);
      this.endTime && (params.endTime = this.endTime);
      this.minMoney && (params.firstAmount = this.minMoney);
      this.maxMoney && (params.lastAmount = this.maxMoney);
      const res = await getInvoiceAmountList(params);
      const { code, data } = res;

      if (code === 200) {
        this.total = data.total;
        this.showList = data.list;
      }
      this.loading = false;
    },

    onMoneyChange(value, type) {
      const val = value.match(/([1-9]\d*|0)(\.\d{0,2})?/) || [""];
      if (type === "min") {
        this.minMoney = val[0];
      } else {
        this.maxMoney = val[0];
      }
    },

    toFillApply() {
      this.step = 2;
      document.documentElement.scrollIntoView();
    },

    changeListType(idx) {
      this.timeType = idx;
      this.submitSearch();
    },

    resetSearch() {
      this.timeType = 0;
      this.status = "";
      this.startTime = "";
      this.endTime = "";
      this.minMoney = "";
      this.maxMoney = "";
      this.submitSearch();
    },

    handleSelectionChange(list) {
      this.selectList = list;
    },

    handlePageChange(page) {
      this.submitSearch(page);
    },

    stepBack(isUpdate) {
      this.step = 1;
      if (isUpdate) {
        document.documentElement.scrollIntoView();
        this.$refs.multipleTable.clearSelection();
        this.submitSearch();
      }
    },
  },
  created() {
    this.getInvoiceAmountTotal();
    this.getInvoiceType();
    this.submitSearch();
  },
};
</script>

<style lang="scss" module scoped>
.container {
  min-height: 300px;
  position: relative;

  .tips {
    font-size: rem(14);
    color: #333;
    line-height: 36px;
    padding-bottom: rem(30);

    p:first-child {
      font-size: max(rem(16), 14px);
      font-weight: bold;
    }
  }

  :global {
    .gl-row {
      padding: rem(50) 0;
    }

    .gl-item {
      margin-right: rem(20);

      ::v-deep .gl-item__name {
        min-width: auto;
      }
    }

    ::v-deep .el-input {
      width: rem(160);
      margin-right: 0;

      .el-input__inner {
        padding: 0 10px;
      }
    }

    .el-select {
      ::v-deep .el-input {
        width: rem(160);
      }
    }

    .el-pagination {
      @include flex();
      margin-top: rem(50);
    }
  }

  .divider {
    width: 6px;
    height: 1px;
    background: #333;
    margin: 0 7px;
  }

  .money_input {
    width: rem(130);
  }

  .money_info {
    display: flex;
    justify-content: space-between;
    padding: rem(30) rem(50);
    margin-bottom: rem(40);
    background: #f6f6f9;

    .money_left {
      width: 60%;
      display: flex;
      justify-content: space-between;

      .money_item {
        @include flex();
        flex-direction: column;
      }

      .money_number {
        font-size: rem(32);
        color: #333;
      }

      .money_name {
        font-size: rem(14);
        color: #333;
        line-height: 24px;
      }
    }

    .money_right {
      @include flex();
      flex-direction: column;
      align-items: flex-end;
      padding-right: rem(30);

      .invoicing_amount {
        font-size: rem(14);
        color: #333;
        line-height: 24px;
        padding-bottom: 10px;
      }

      .apply_btn {
        min-width: rem(90);
        margin: 0;
      }
    }
  }

  .time_type {
    height: rem(60);
    margin-bottom: rem(20);
    display: flex;
    align-items: center;

    > span {
      font-size: max(rem(16), 14px);
      color: #333;
      margin-right: rem(50);
      cursor: pointer;

      &.btn_active {
        color: $theme-color;
      }
    }

    .total {
      font-size: max(rem(16), 14px);
      color: $theme-color;
      font-weight: bold;
    }
  }
}
</style>
